import { useQuery } from '@tanstack/react-query';

import { get } from '../../../lib/api';

export const useGetBroadcastReports = ({ limit, page }) => {
  const params = {
    limit,
    page,
  };

  const {
    data = {
      data: { reports: [] },
      totalBroadcasts: 0,
      linkTrackingDisabled: false,
    },
    isLoading,
    isFetched,
  } = useQuery(
    ['getBroadcastReports', params],
    () => get('/api/client_admin/reports/broadcast_messages', params),
    {
      keepPreviousData: true,
    },
  );

  return { data, isLoading, isFetched };
};
